import { render, staticRenderFns } from "./SolePropE.vue?vue&type=template&id=f9660a9a"
import script from "./SolePropE.vue?vue&type=script&lang=js"
export * from "./SolePropE.vue?vue&type=script&lang=js"
import style0 from "./SolePropE.vue?vue&type=style&index=0&id=f9660a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports